module.exports = __webpack_public_path__ + "img/logo.3163ca94.png";